import React, { Component } from 'react'
import SRCards from '../../components/SRCards'
import update from 'immutability-helper';
import CustomerApi from '../../services/customer.service'
import {
    Button, Container, Checkbox, Paper, TableContainer, TextField, Table,
    TableHead, TableRow, TableCell, TableBody, Typography, TableFooter, Grid, Box, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Snackbar
} from '@material-ui/core'
import { Alert, ToggleButton, ToggleButtonGroup } from '@material-ui/lab';

const BILLING = 'billing';
const SERVICE = 'service';

type IProps = {
    location: any
}
type IState = {
    idPrimary: any;
    idDuplicate: any;
    customersPrimary: any,
    selectionsPrimary: any;
    customersDuplicate: any,
    selectionsDuplicate: any;
    customerTypePrimary: any;
    customerTypeDuplicate: any;
    mergeType: any;
    dialog: any;
    snackBar: any;
    confirmMsg: any;
    pageResponse: any;
}
const apiservices = new CustomerApi();

class CustomerMerge extends Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            idPrimary: [],
            idDuplicate: [],
            customersPrimary: [],
            customersDuplicate: [],
            selectionsPrimary: {},
            selectionsDuplicate: {},
            customerTypePrimary: null,
            customerTypeDuplicate: null,
            mergeType: BILLING,
            dialog: false,
            snackBar: '',
            confirmMsg: '',
            pageResponse: null
        };
    }

    handleSelectPrimary = (id: any) => {
        this.setState((prevState) => {
            if (prevState.selectionsPrimary[id]) {
                return update(prevState, {
                    selectionsPrimary: { $unset: [id] },
                });
            }
            return update(prevState, {
                selectionsPrimary: { [id]: { $set: true } },
            });
        });
    }
    isItemSelectedPrimary = (id: string | number) => this.state.selectionsPrimary[id];

    async onSearchPrimary(e: any) {
        const response = await apiservices.getCustomers(
            e.target.value
        );
        this.setState({
            customersPrimary: response
        })
    }

    handleSelectDuplicate = (id: any) => {
        this.setState((prevState) => {
            if (prevState.selectionsDuplicate[id]) {
                return update(prevState, {
                    selectionsDuplicate: { $unset: [id] },
                });
            }
            return update(prevState, {
                selectionsDuplicate: { [id]: { $set: true } },
            });
        });
    }
    isItemSelectedDuplicate = (id: string | number) => this.state.selectionsDuplicate[id];

    async onSearchDuplicate(e: any) {
        const response = await apiservices.getCustomers(
            e.target.value
        );
        this.setState({
            customersDuplicate: response
        })
    }

    async onSubmit() {
        let { mergeType } = this.state;
        let { customerTypePrimary } = this.state;
        let { customerTypeDuplicate } = this.state;
        let primaryCustomerUniqueId, secondaryCustomerUniqueId, params,
            primaryCustomer: any, duplicateCustomer: any;
        console.log("primaryCustomer : ", this.state.idPrimary);
        console.log("seondaryCustomer : ", this.state.idDuplicate);
        if (mergeType === BILLING) {
            primaryCustomerUniqueId = this.state.idPrimary[0].customerIdentifier;
            secondaryCustomerUniqueId = this.state.idDuplicate[0].customerIdentifier;
        } else {
            primaryCustomerUniqueId = this.state.idPrimary[0].customerUniqueId;
            secondaryCustomerUniqueId = this.state.idDuplicate[0].customerUniqueId;
        }

        params = {
            mergeType: mergeType,
            primaryCustomerUniqueId: primaryCustomerUniqueId,
            secondaryCustomerUniqueId: secondaryCustomerUniqueId
        }
        let response = await apiservices.mergeCustomer(params);
        if (response && response.status) {
            this.setState({
                dialog: false,
                snackBar: 'success',
                pageResponse: `Merged ${response.status}`
            })
        }
        // else {
        //     let msg;
        //     if(response && response.message && response.description) {
        //         if(response.description.includes('mergeServiceAddress')) {
        //             msg = `Merge Failed: Service Merge is not supported in SRP. To move a service address to another billing address select Billing merge in toggle`
        //         } else {
        //             msg = `Merge Failed: ${response.message} - ${response.description}`
        //         }
        //     } else {
        //         msg = `Merge Failed.`
        //     }
        //     this.setState({
        //         dialog: false,
        //         snackBar: 'error',
        //         pageResponse: msg
        //     })
        // }
    }

    async confirm() {
        if (this.state.idPrimary.length > 1 || this.state.idDuplicate.length > 1) {
            this.setState({
                dialog: true,
                confirmMsg: 'You can select only 1 primary and 1 duplicate customer to merge.'
            })
        }
        else {
            let res = `This update will affect all the service addresses, tickets,
                    invoices, estimates and other related data to the customer.`
            this.setState({
                dialog: true,
                confirmMsg: res
            })
        }
    }

    async cancel() {
        this.setState({
            dialog: false,
            snackBar: 'info',
            pageResponse: "Merge Cancelled."
        })
    }

    render() {
        return (
            <div>
                <SRCards />
                <Container>
                    <Typography
                        style={{ padding: 16 }}
                    >
                        {localStorage.getItem('selectedCompanyDisplay')}
                    </Typography>
                    <Box ml={60} mb={10}>
                        <ToggleButtonGroup value={this.state.mergeType}>
                            <ToggleButton value={BILLING} onClick={() => {
                                this.setState({
                                    mergeType: BILLING,
                                })

                            }}>
                                <Typography>Billing Merge</Typography>
                            </ToggleButton>
                            <ToggleButton value={SERVICE} onClick={() => {
                                this.setState({
                                    mergeType: SERVICE,
                                })

                            }}>
                                <Typography>Service Merge</Typography>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                    <Button
                        style={{ margin: 10 }}
                        disabled={this.state.idPrimary.length > 0 &&
                            this.state.idDuplicate.length > 0 ?
                            false :
                            true}
                        size='large'
                        variant='outlined'
                        onClick={this.confirm.bind(this)}>
                        Merge
                    </Button>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Typography>
                                Select the Primary Customer
                            </Typography>
                            <TextField
                                style={{ padding: 16 }}
                                variant="outlined"
                                onChange={(e) => this.onSearchPrimary(e)}
                                placeholder='Search Primary Customer..' />
                            <TableContainer
                                component={Paper}
                                style={{
                                    padding: 10, margin: 16
                                }}
                            >
                                <Table
                                    style={{
                                        minWidth: 700
                                    }}
                                    aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Select</TableCell>
                                            <TableCell>Customer Name</TableCell>
                                            <TableCell>Customer ID</TableCell>
                                            <TableCell>Customer Type</TableCell>
                                            <TableCell>Primary/Secondary</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    {this.state.customersPrimary.length > 0 ?
                                        this.state.customersPrimary.map((set: any) => {
                                            return (
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>
                                                            <Checkbox
                                                                key={set.id}
                                                                defaultChecked={false}
                                                                checked={
                                                                    this.isItemSelectedPrimary(set.id)
                                                                }
                                                                onChange={() => {
                                                                    this.handleSelectPrimary(set.id)
                                                                    if (!this.state.idPrimary.includes(set)) {
                                                                        this.state.idPrimary.push(set)
                                                                    }
                                                                    else {
                                                                        const i = this.state.idPrimary.indexOf(set);
                                                                        this.state.idPrimary.splice(i, 1)
                                                                    }
                                                                    this.setState({
                                                                        idPrimary: this.state.idPrimary,
                                                                        customerTypePrimary: 0
                                                                    })
                                                                }
                                                                } />
                                                        </TableCell>
                                                        <TableCell>
                                                            {set.displayName}
                                                        </TableCell>
                                                        <TableCell>
                                                            {set.customerIdentifier}
                                                        </TableCell>
                                                        <TableCell>
                                                            Root Customer
                                                        </TableCell>
                                                        <TableCell>
                                                            Primary
                                                        </TableCell>
                                                    </TableRow>
                                                    {set.serviceAddresses.length > 1 ?
                                                        set.serviceAddresses
                                                            .map((temp: any) => {
                                                                return (
                                                                    <TableRow>
                                                                        <TableCell>
                                                                            <Checkbox
                                                                                key={temp.id}
                                                                                defaultChecked={false}
                                                                                checked={
                                                                                    this.isItemSelectedPrimary(temp.id)
                                                                                }
                                                                                onChange={() => {
                                                                                    this.handleSelectPrimary(temp.id)
                                                                                    if (!this.state.idPrimary.includes(temp)) {
                                                                                        this.state.idPrimary.push(temp)
                                                                                    }
                                                                                    else {
                                                                                        const i = this.state.idPrimary.indexOf(temp);
                                                                                        this.state.idPrimary.splice(i, 1)
                                                                                    }
                                                                                    this.setState({
                                                                                        idPrimary: this.state.idPrimary,
                                                                                        customerTypePrimary: 1
                                                                                    })
                                                                                }
                                                                                } />
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {temp.displayName}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {temp.customerIdentifier}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            Service
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {temp.isParent ? 'Primary' : 'Secondary'}
                                                                        </TableCell>
                                                                    </TableRow>)
                                                            }) : null}
                                                </TableBody>
                                            )
                                        }) : null}
                                    <TableFooter>
                                        <TableRow>

                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography>
                                Select the Duplicate Customer
                            </Typography>
                            <TextField
                                style={{ padding: 16 }}
                                variant="outlined"
                                onChange={(e) => this.onSearchDuplicate(e)}
                                placeholder='Search Secondary Customer..' />
                            <TableContainer
                                component={Paper}
                                style={{
                                    padding: 10, margin: 16
                                }}
                            >
                                <Table
                                    style={{
                                        minWidth: 700
                                    }}
                                    aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Select</TableCell>
                                            <TableCell>Customer Name</TableCell>
                                            <TableCell>Customer ID</TableCell>
                                            <TableCell>Customer Type</TableCell>
                                            <TableCell>Primary/Secondary</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    {this.state.customersDuplicate.length > 0 ?
                                        this.state.customersDuplicate.map((set: any) => {
                                            return (
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>
                                                            <Checkbox
                                                                key={set.id}
                                                                defaultChecked={false}
                                                                checked={
                                                                    this.isItemSelectedDuplicate(set.id)
                                                                }
                                                                onChange={() => {
                                                                    this.handleSelectDuplicate(set.id)
                                                                    if (!this.state.idDuplicate.includes(set)) {
                                                                        this.state.idDuplicate.push(set)
                                                                    }
                                                                    else {
                                                                        const i = this.state.idDuplicate.indexOf(set);
                                                                        this.state.idDuplicate.splice(i, 1)
                                                                    }
                                                                    this.setState({
                                                                        idDuplicate: this.state.idDuplicate,
                                                                        customerTypeDuplicate: 0
                                                                    })
                                                                }
                                                                } />
                                                        </TableCell>
                                                        <TableCell>
                                                            {set.displayName}
                                                        </TableCell>
                                                        <TableCell>
                                                            {set.customerIdentifier}
                                                        </TableCell>
                                                        <TableCell>
                                                            Root Customer
                                                        </TableCell>
                                                        <TableCell>
                                                            Primary
                                                        </TableCell>
                                                    </TableRow>
                                                    {set.serviceAddresses.length > 1 ?
                                                        set.serviceAddresses
                                                            .map((temp: any) => {
                                                                return (
                                                                    <TableRow>
                                                                        <TableCell>
                                                                            <Checkbox
                                                                                key={temp.id}
                                                                                defaultChecked={false}
                                                                                checked={
                                                                                    this.isItemSelectedDuplicate(temp.id)
                                                                                }
                                                                                onChange={() => {
                                                                                    this.handleSelectDuplicate(temp.id)
                                                                                    if (!this.state.idDuplicate.includes(temp)) {
                                                                                        this.state.idDuplicate.push(temp)
                                                                                    }
                                                                                    else {
                                                                                        const i = this.state.idDuplicate.indexOf(temp);
                                                                                        this.state.idDuplicate.splice(i, 1)
                                                                                    }
                                                                                    this.setState({
                                                                                        idDuplicate: this.state.idDuplicate,
                                                                                        customerTypeDuplicate: 1
                                                                                    })
                                                                                }
                                                                                } />
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {temp.displayName}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {temp.customerIdentifier}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            Service
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {temp.isParent ? 'Primary' : 'Secondary'}
                                                                        </TableCell>
                                                                    </TableRow>)
                                                            }) : null}
                                                </TableBody>
                                            )
                                        }) : null}
                                    <TableFooter>
                                        <TableRow>

                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    <Dialog
                        open={this.state.dialog}
                        onClose={() => {
                            this.setState({
                                dialog: false
                            })
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            {this.state.confirmMsg.includes('Do not') ?
                                'Note' :
                                'Confirmation!'
                            }
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText
                                id="alert-dialog-description"
                            >
                                {this.state.confirmMsg}
                            </DialogContentText>
                        </DialogContent>
                        {this.state.confirmMsg.includes('Do not') ?
                            <DialogActions>
                                <Button
                                    onClick={
                                        () => {
                                            this.setState({
                                                dialog: false
                                            })
                                        }
                                    }
                                >
                                    Close
                                </Button>
                            </DialogActions>
                            :
                            <DialogActions>
                                <Button
                                    onClick={
                                        () => {
                                            this.setState({
                                                confirmMsg: 'Processing...'
                                            })
                                            this.onSubmit()
                                        }
                                    }
                                >
                                    Confirm
                                </Button>
                                <Button
                                    onClick={
                                        () => this.cancel()
                                    }
                                    autoFocus
                                >
                                    Cancel
                                </Button>
                            </DialogActions>
                        }
                    </Dialog>
                    <Snackbar
                        open={this.state.snackBar === '' ? false : true}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        autoHideDuration={6000}
                        onClose={() => {
                            this.setState({
                                snackBar: ''
                            })
                        }}
                    >
                        <Alert
                            severity={this.state.snackBar}
                            onClose={() => {
                                this.setState({
                                    snackBar: ''
                                })
                            }
                            }>
                            {this.state.pageResponse}
                        </Alert>
                    </Snackbar>
                </Container>
            </div>
        )
    }
}

export default CustomerMerge;